import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import BusinessCustomerDropShip from './Checkout.BusinessCustomerDropShip';
import BusinessCustomerShippingAddress from './Checkout.BusinessCustomerShippingAddress';
import { setDropShipping } from '../Actions/Checkout.action';

const CheckoutBusinessCustomerShippingInfo = () => {
    const dispatch = useDispatch();
    const { payload, errors = {} } = useSelector((state) => state.checkout);
    const [isDropShipSelected, setDropShipSelected] = useState(false);
    const [isStoreSelected, setStoreSelected] = useState(true);
    const [shipping, setShipping] = useState(false);
    const { authenticated, shippingTypes, dropShipping } = payload;

    const onShippingTypeChange = (value) => {
        const dropShipping = value === 'true';
        setShipping(dropShipping);
        dispatch(setDropShipping(dropShipping));
    };

    useEffect(() => {
        setDropShipSelected(shipping);
        setStoreSelected(!shipping);
    }, [shipping]);

    return (
        <div className="row checkout-info__container">
            <div className="small-12 medium-6 checkout-column columns">
                <div className="row-inner">
                    <div className="small-12 columns">
                        {translate('checkout.shipping.type')}
                    </div>
                    <div className="small-12 columns">
                        <label
                            className="form__label"
                            htmlFor="checkout.shipping.shippingtype"
                        >
                            {translate(
                                'checkout.shipping.shippingtype.placeholder'
                            )}
                        </label>
                        <select
                            className="form__input"
                            id="checkout.shipping.shippingtype"
                            value={dropShipping}
                            disabled={!authenticated}
                            onChange={(event) =>
                                onShippingTypeChange(event.target.value)
                            }
                        >
                            {shippingTypes &&
                                shippingTypes.map((type) => (
                                    <option
                                        value={type.dropShipping}
                                        key={type.name}
                                    >
                                        {type.name}
                                    </option>
                                ))}
                        </select>
                        {errors['dropShipping'] && (
                            <span
                                className="form__validator--error form__validator--top-narrow"
                                data-error-for="dropShipping"
                            >
                                {errors['dropShipping'][0]}
                            </span>
                        )}
                    </div>
                </div>
                {isDropShipSelected && !isStoreSelected && (
                    <BusinessCustomerDropShip />
                )}
                {isStoreSelected && !isDropShipSelected && (
                    <BusinessCustomerShippingAddress />
                )}
            </div>
        </div>
    );
};

export default CheckoutBusinessCustomerShippingInfo;
